"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STANDARD_COMBO_TYPES = exports.CLEAN_COMBO_TYPES = exports.DEFAULT_COMBO_LOCK_DAYS = exports.COMBO_REVIEW_DISCARD_REASONS = exports.COMBO_REVIEW_DISCARD_REASON_ERROR = exports.COMBO_REVIEW_DISCARD_REASON_OVERBOOKING = exports.COMBO_REVIEW_DISCARD_REASON_NOT_ACCEPTED = void 0;
exports.COMBO_REVIEW_DISCARD_REASON_NOT_ACCEPTED = "Offer was not accepted";
exports.COMBO_REVIEW_DISCARD_REASON_OVERBOOKING = "Driver is busy/overbooked";
exports.COMBO_REVIEW_DISCARD_REASON_ERROR = "Failed to post the offer automatically";
exports.COMBO_REVIEW_DISCARD_REASONS = [
    "Combo no longer exists",
    exports.COMBO_REVIEW_DISCARD_REASON_OVERBOOKING,
    exports.COMBO_REVIEW_DISCARD_REASON_NOT_ACCEPTED,
    "Waiting time is too short",
    "Locked combo is missing a replacement trip",
    "Driver didn't accept a replacement for locked combo",
    "Driver coverage is insufficient",
    "Other",
];
exports.DEFAULT_COMBO_LOCK_DAYS = 35;
exports.CLEAN_COMBO_TYPES = ["Clean", "CleanMultiday"];
exports.STANDARD_COMBO_TYPES = ["Clean", "CleanMultiday", "Personal", "PersonalMultiday"];
//# sourceMappingURL=combo.js.map